// Auto-detect the user's likely currency from their browser locale.
// Falls back to GBP.
const EUROZONE = new Set(["DE","FR","IT","ES","NL","BE","AT","IE","PT","GR","FI","SK","SI","LU","LV","LT","EE","CY","MT","HR"]);
const USD_COUNTRIES = new Set(["US","PR","EC","SV","PA"]);

export function detectCurrency() {
  try {
    // Region code from navigator.language (e.g. en-GB → GB)
    const lang = navigator.language || navigator.languages?.[0] || "";
    const parts = lang.split("-");
    const region = (parts[1] || parts[0] || "").toUpperCase();
    if (EUROZONE.has(region)) return "eur";
    if (USD_COUNTRIES.has(region)) return "usd";
    if (region === "GB") return "gbp";
    // Language-only hint (fr → EUR, de → EUR, en → GBP)
    const lower = (parts[0] || "").toLowerCase();
    if (["fr","de","it","es","nl","pt","el","fi","sk","sl","lt","et","hr"].includes(lower)) return "eur";
    if (lower === "en") return "gbp";
  } catch { /* ignore */ }
  return "gbp";
}

export const CURRENCY_SYMBOL = { gbp: "£", usd: "$", eur: "€" };

export function formatMoney(cents, currency) {
  const amt = (cents || 0) / 100;
  try {
    return new Intl.NumberFormat(navigator.language || "en-GB", {
      style: "currency", currency: (currency || "gbp").toUpperCase(), minimumFractionDigits: 2,
    }).format(amt);
  } catch {
    return `${CURRENCY_SYMBOL[currency] || "£"}${amt.toFixed(2)}`;
  }
}
